"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _qs = require("qs");

var _bluebird = _interopRequireDefault(require("bluebird"));

var _basic = _interopRequireDefault(require("./_basic"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function paramsSerializer(params) {
  return (0, _qs.stringify)(params, {
    arrayFormat: 'brackets'
  });
}

var StoreApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(StoreApi, _BasicApi);

  /**
   * @constructor
   */
  function StoreApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        storeApiUrl = _ref.storeApiUrl;
    (0, _classCallCheck2.default)(this, StoreApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(StoreApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.storeApiUrl = storeApiUrl;
    return _this;
  } // sb


  (0, _createClass2.default)(StoreApi, [{
    key: "getPackages",
    value: function () {
      var _getPackages = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(params, _ref2) {
        var _this2 = this;

        var type, signal, _ref3, headers;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _ref2.type, signal = _ref2.signal;
                _context.next = 3;
                return this.getHeaders();

              case 3:
                _ref3 = _context.sent;
                headers = _ref3.headers;
                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this2.storeApiUrl, "/api/v1/packages/").concat(type), {
                    headers: headers,
                    signal: signal,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPackages(_x, _x2) {
        return _getPackages.apply(this, arguments);
      }

      return getPackages;
    }() // library

  }, {
    key: "getSandbox",
    value: function () {
      var _getSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(params, _ref4) {
        var _this3 = this;

        var type, signal, _ref5, headers;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                type = _ref4.type, signal = _ref4.signal;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                _ref5 = _context2.sent;
                headers = _ref5.headers;
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this3.storeApiUrl, "/api/v1/sandbox/").concat(type), {
                    headers: headers,
                    signal: signal,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSandbox(_x3, _x4) {
        return _getSandbox.apply(this, arguments);
      }

      return getSandbox;
    }() // sb

  }, {
    key: "getCategories",
    value: function () {
      var _getCategories = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(params, _ref6) {
        var _this4 = this;

        var type, signal, _ref7, headers;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = _ref6.type, signal = _ref6.signal;
                _context3.next = 3;
                return this.getHeaders();

              case 3:
                _ref7 = _context3.sent;
                headers = _ref7.headers;
                return _context3.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this4.storeApiUrl, "/api/v1/categories/").concat(type), {
                    headers: headers,
                    signal: signal,
                    params: params
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCategories(_x5, _x6) {
        return _getCategories.apply(this, arguments);
      }

      return getCategories;
    }()
  }, {
    key: "putCategory",
    value: function () {
      var _putCategory = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(payload) {
        var _this5 = this;

        var _ref8,
            type,
            signal,
            customHeaders,
            _ref9,
            defaultHeaders,
            headers,
            _args4 = arguments;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref8 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {}, type = _ref8.type, signal = _ref8.signal, customHeaders = _ref8.headers;
                _context4.next = 3;
                return this.getHeaders();

              case 3:
                _ref9 = _context4.sent;
                defaultHeaders = _ref9.headers;
                headers = _objectSpread({}, defaultHeaders, {}, customHeaders);
                return _context4.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.put("".concat(_this5.storeApiUrl, "/api/v1/categories/").concat(type), payload, {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function putCategory(_x7) {
        return _putCategory.apply(this, arguments);
      }

      return putCategory;
    }()
  }, {
    key: "getCategoryById",
    value: function () {
      var _getCategoryById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(_ref10, _ref11) {
        var _this6 = this;

        var id, type, signal, _ref12, headers;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                id = _ref10.id;
                type = _ref11.type, signal = _ref11.signal;
                _context5.next = 4;
                return this.getHeaders();

              case 4:
                _ref12 = _context5.sent;
                headers = _ref12.headers;
                return _context5.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this6.storeApiUrl, "/api/v1/categories/").concat(type, "/id/").concat(id), {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getCategoryById(_x8, _x9) {
        return _getCategoryById.apply(this, arguments);
      }

      return getCategoryById;
    }() // sb

  }, {
    key: "getUploadCredentials",
    value: function () {
      var _getUploadCredentials = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(payload, _ref13) {
        var _this7 = this;

        var type, signal, customHeaders, _ref14, defaultHeaders, headers, id, version;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                type = _ref13.type, signal = _ref13.signal, customHeaders = _ref13.headers;
                _context6.next = 3;
                return this.getHeaders();

              case 3:
                _ref14 = _context6.sent;
                defaultHeaders = _ref14.headers;
                headers = _objectSpread({}, defaultHeaders, {}, customHeaders);
                id = payload.id, version = payload.version;
                return _context6.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this7.storeApiUrl, "/api/v1/packages/").concat(type, "/id/").concat(id, "/version/").concat(version), payload, {
                    headers: headers,
                    signal: signal
                  }).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getUploadCredentials(_x10, _x11) {
        return _getUploadCredentials.apply(this, arguments);
      }

      return getUploadCredentials;
    }() // sb

  }, {
    key: "getUploadCredentialsSandbox",
    value: function () {
      var _getUploadCredentialsSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(payload, _ref15) {
        var _this8 = this;

        var type, signal, _ref16, headers, id, version;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                type = _ref15.type, signal = _ref15.signal;
                _context7.next = 3;
                return this.getHeaders();

              case 3:
                _ref16 = _context7.sent;
                headers = _ref16.headers;
                id = payload.id, version = payload.version;
                return _context7.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this8.storeApiUrl, "/api/v1/sandbox/").concat(type, "/id/").concat(id, "/version/").concat(version), payload, {
                    headers: headers,
                    signal: signal
                  }).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getUploadCredentialsSandbox(_x12, _x13) {
        return _getUploadCredentialsSandbox.apply(this, arguments);
      }

      return getUploadCredentialsSandbox;
    }() // sb, fb pick ['version', 'baseUrl']

  }, {
    key: "getVersions",
    value: function () {
      var _getVersions = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref17, _ref18) {
        var _this9 = this;

        var id, isSandbox, includeDeprecated, includeReleaseNotes, type, signal, index, _ref19, headers, params;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                id = _ref17.id, isSandbox = _ref17.isSandbox, includeDeprecated = _ref17.includeDeprecated, includeReleaseNotes = _ref17.includeReleaseNotes;
                type = _ref18.type, signal = _ref18.signal;
                index = isSandbox ? 'sandbox' : 'packages';
                _context8.next = 5;
                return this.getHeaders();

              case 5:
                _ref19 = _context8.sent;
                headers = _ref19.headers;
                params = {
                  includeDeprecated: includeDeprecated,
                  includeReleaseNotes: includeReleaseNotes
                };
                return _context8.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this9.storeApiUrl, "/api/v1/").concat(index, "/").concat(type, "/id/").concat(id), {
                    headers: headers,
                    signal: signal,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getVersions(_x14, _x15) {
        return _getVersions.apply(this, arguments);
      }

      return getVersions;
    }() // sb void

  }, {
    key: "deletePackageVersionFromSandbox",
    value: function () {
      var _deletePackageVersionFromSandbox = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref20, _ref21) {
        var _this10 = this;

        var id, version, type, signal, _ref22, headers;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                id = _ref20.id, version = _ref20.version;
                type = _ref21.type, signal = _ref21.signal;
                _context9.next = 4;
                return this.getHeaders();

              case 4:
                _ref22 = _context9.sent;
                headers = _ref22.headers;
                return _context9.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete("".concat(_this10.storeApiUrl, "/api/v1/sandbox/").concat(type, "/id/").concat(id, "/version/").concat(version), {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deletePackageVersionFromSandbox(_x16, _x17) {
        return _deletePackageVersionFromSandbox.apply(this, arguments);
      }

      return deletePackageVersionFromSandbox;
    }() // sb {version}

  }, {
    key: "getPackageMetaLatestVersionById",
    value: function () {
      var _getPackageMetaLatestVersionById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref23, _ref24) {
        var _this11 = this;

        var id, type, signal, _ref25, headers;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                id = _ref23.id;
                type = _ref24.type, signal = _ref24.signal;
                _context10.next = 4;
                return this.getHeaders();

              case 4:
                _ref25 = _context10.sent;
                headers = _ref25.headers;
                return _context10.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this11.storeApiUrl, "/api/v1/packages/").concat(type, "/id/").concat(id, "/latest"), {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 7:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getPackageMetaLatestVersionById(_x18, _x19) {
        return _getPackageMetaLatestVersionById.apply(this, arguments);
      }

      return getPackageMetaLatestVersionById;
    }() // datahub, library

  }, {
    key: "getMetaByVersion",
    value: function () {
      var _getMetaByVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11(_ref26, _ref27) {
        var _this12 = this;

        var id, version, isSandbox, type, signal, index, _ref28, headers;

        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                id = _ref26.id, version = _ref26.version, isSandbox = _ref26.isSandbox;
                type = _ref27.type, signal = _ref27.signal;
                index = isSandbox ? 'sandbox' : 'packages';
                _context11.next = 5;
                return this.getHeaders();

              case 5:
                _ref28 = _context11.sent;
                headers = _ref28.headers;
                return _context11.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this12.storeApiUrl, "/api/v1/").concat(index, "/").concat(type, "/id/").concat(id, "/version/").concat(version), {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getMetaByVersion(_x20, _x21) {
        return _getMetaByVersion.apply(this, arguments);
      }

      return getMetaByVersion;
    }()
  }, {
    key: "getFavorites",
    value: function () {
      var _getFavorites = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(params, _ref29) {
        var _this13 = this;

        var type, signal, _ref30, headers;

        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                type = _ref29.type, signal = _ref29.signal;
                _context12.next = 3;
                return this.getHeaders();

              case 3:
                _ref30 = _context12.sent;
                headers = _ref30.headers;
                return _context12.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this13.storeApiUrl, "/api/v1/packages/").concat(type, "/favorites"), {
                    headers: headers,
                    signal: signal,
                    params: params,
                    paramsSerializer: paramsSerializer
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getFavorites(_x22, _x23) {
        return _getFavorites.apply(this, arguments);
      }

      return getFavorites;
    }()
  }, {
    key: "submitLegacyStepJson",
    value: function () {
      var _submitLegacyStepJson = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(stepTemplate) {
        var _this14 = this;

        var _ref31,
            signal,
            type,
            _ref32,
            headers,
            id,
            _stepTemplate$version,
            version,
            payload,
            _args13 = arguments;

        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _ref31 = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : {}, signal = _ref31.signal;
                type = "STEP";
                _context13.next = 4;
                return this.getHeaders();

              case 4:
                _ref32 = _context13.sent;
                headers = _ref32.headers;
                id = stepTemplate.id, _stepTemplate$version = stepTemplate.version, version = _stepTemplate$version === void 0 ? "0.0.1" : _stepTemplate$version;
                payload = {
                  data: stepTemplate,
                  name: stepTemplate.label,
                  description: stepTemplate.description,
                  categories: stepTemplate.categories
                };
                return _context13.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.put("".concat(_this14.storeApiUrl, "/api/v1/service/sync/").concat(type, "/legacy/id/").concat(id, "/version/").concat(version, "/json"), payload, {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 9:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function submitLegacyStepJson(_x24) {
        return _submitLegacyStepJson.apply(this, arguments);
      }

      return submitLegacyStepJson;
    }()
  }, {
    key: "syncLegacyStepFromLibrary",
    value: function () {
      var _syncLegacyStepFromLibrary = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref33) {
        var _this15 = this;

        var id,
            _ref34,
            signal,
            type,
            _ref35,
            headers,
            _args14 = arguments;

        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                id = _ref33.id;
                _ref34 = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : {}, signal = _ref34.signal;
                type = "STEP";
                _context14.next = 5;
                return this.getHeaders();

              case 5:
                _ref35 = _context14.sent;
                headers = _ref35.headers;
                return _context14.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.put("".concat(_this15.storeApiUrl, "/api/v1/service/sync/").concat(type, "/legacy/id/").concat(id, "/latest"), {}, {
                    headers: headers,
                    signal: signal
                  });
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function syncLegacyStepFromLibrary(_x25) {
        return _syncLegacyStepFromLibrary.apply(this, arguments);
      }

      return syncLegacyStepFromLibrary;
    }()
  }, {
    key: "setReleaseStatus",
    value: function () {
      var _setReleaseStatus = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(payload) {
        var _this16 = this;

        var _ref36,
            type,
            signal,
            _ref37,
            headers,
            id,
            version,
            scope,
            repository,
            _args15 = arguments;

        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _ref36 = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : {}, type = _ref36.type, signal = _ref36.signal;
                _context15.next = 3;
                return this.getHeaders();

              case 3:
                _ref37 = _context15.sent;
                headers = _ref37.headers;
                id = payload.id, version = payload.version, scope = payload.scope;
                repository = payload.repository;

                if (scope && !repository) {
                  // scope is deprecated
                  console.warn('Using "scope" is deprecated. Use "repository" instead'); // eslint-disable-line no-undef

                  repository = scope;
                }

                return _context15.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this16.storeApiUrl, "/api/v1/packages/").concat(type, "/id/").concat(id, "/version/").concat(version, "/status/release/").concat(repository), payload, {
                    headers: headers,
                    signal: signal
                  }).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setReleaseStatus(_x26) {
        return _setReleaseStatus.apply(this, arguments);
      }

      return setReleaseStatus;
    }()
  }, {
    key: "setReleaseStatusToBeta",
    value: function () {
      var _setReleaseStatusToBeta = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(payload) {
        var _ref38,
            type,
            signal,
            status,
            _args16 = arguments;

        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _ref38 = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {}, type = _ref38.type, signal = _ref38.signal;
                status = "BETA";
                return _context16.abrupt("return", this.setReleaseStatus(_objectSpread({}, payload, {
                  status: status
                }), {
                  type: type,
                  signal: signal
                }));

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function setReleaseStatusToBeta(_x27) {
        return _setReleaseStatusToBeta.apply(this, arguments);
      }

      return setReleaseStatusToBeta;
    }()
  }, {
    key: "setReleaseStatusToReleased",
    value: function () {
      var _setReleaseStatusToReleased = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(payload) {
        var _ref39,
            type,
            signal,
            status,
            _args17 = arguments;

        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _ref39 = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : {}, type = _ref39.type, signal = _ref39.signal;
                status = "RELEASED";
                return _context17.abrupt("return", this.setReleaseStatus(_objectSpread({}, payload, {
                  status: status
                }), {
                  type: type,
                  signal: signal
                }));

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function setReleaseStatusToReleased(_x28) {
        return _setReleaseStatusToReleased.apply(this, arguments);
      }

      return setReleaseStatusToReleased;
    }()
  }, {
    key: "setReleaseStatusToDeprecated",
    value: function () {
      var _setReleaseStatusToDeprecated = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(payload) {
        var _ref40,
            type,
            signal,
            status,
            _args18 = arguments;

        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _ref40 = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : {}, type = _ref40.type, signal = _ref40.signal;
                status = "DEPRECATED";
                return _context18.abrupt("return", this.setReleaseStatus(_objectSpread({}, payload, {
                  status: status
                }), {
                  type: type,
                  signal: signal
                }));

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function setReleaseStatusToDeprecated(_x29) {
        return _setReleaseStatusToDeprecated.apply(this, arguments);
      }

      return setReleaseStatusToDeprecated;
    }()
  }, {
    key: "deprecateLegacyStep",
    value: function () {
      var _deprecateLegacyStep = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(payload) {
        var _ref41,
            signal,
            type,
            _args19 = arguments;

        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _ref41 = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : {}, signal = _ref41.signal;
                type = "STEP";
                return _context19.abrupt("return", this.setReleaseStatusToDeprecated(payload, {
                  type: type,
                  signal: signal
                }));

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function deprecateLegacyStep(_x30) {
        return _deprecateLegacyStep.apply(this, arguments);
      }

      return deprecateLegacyStep;
    }()
  }, {
    key: "deprecateLegacySteps",
    value: function () {
      var _deprecateLegacySteps = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee20(payload) {
        var _this17 = this;

        var _ref42,
            signal,
            _ref43,
            headers,
            type,
            _args20 = arguments;

        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _ref42 = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : {}, signal = _ref42.signal;
                _context20.next = 3;
                return this.getHeaders();

              case 3:
                _ref43 = _context20.sent;
                headers = _ref43.headers;
                type = "STEP";
                return _context20.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this17.storeApiUrl, "/api/v1/service/sync/").concat(type, "/legacy/deprecate"), payload, {
                    headers: headers,
                    signal: signal
                  }).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 7:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function deprecateLegacySteps(_x31) {
        return _deprecateLegacySteps.apply(this, arguments);
      }

      return deprecateLegacySteps;
    }()
  }]);
  return StoreApi;
}(_basic.default);

var _default = StoreApi;
exports.default = _default;